import styled from 'styled-components/macro';
import { fontSize } from '@notonthehighstreet/toolkit/utils';

const Text = styled.span(
  {
    fontSize: fontSize('s'),
  },
  ({ secondary = false }) => ({
    color: secondary ? '#afafaf' : '#2e2e2e',
  }),
  ({ textAlign = 'left' }) => ({
    textAlign,
  }),
  ({ size = 's' }) => ({
    fontSize: fontSize(size),
  })
);

Text.displayName = 'Text';
export default Text;
